import { bunja } from 'bunja';
import { atom } from 'jotai';

import { postUserPasswordApi } from '@flipster/apis/v1/user';
import { User } from '@flipster/apis/v1/user/types';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { RouterScope } from '@flipster/react/providers/route';
import { convertDate } from '@flipster/utils/datetime';

// context:
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728872045872999
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728963201328899
// - https://prextech.slack.com/archives/C07BK9M6SLA/p1728963317151339
export const ninetyDaysPasswordUpdateBunja = bunja(() => {
  const router = bunja.use(RouterScope);
  const modalOpenAtom = atom<boolean>(false);

  function shouldShowModal(passwordChangeRequiredAt: Date | null): boolean {
    if (!passwordChangeRequiredAt) return false;
    return passwordChangeRequiredAt < new Date();
  }

  function openPasswordChangeRequiredModal(me: User): void {
    if (!shouldShowModal(convertDate(me.passwordChangeRequiredAt))) return;
    dialog.open({
      title: {
        label: 'Password update needed',
      },
      content: 'For better security, we recommend updating your password.',
      buttons: {
        primary: (
          <Dialog.Button
            hierarchy='primary'
            label='Update now'
            onClick={() => {
              router.push('/user/account?openModal=password%3Achange');
            }}
          />
        ),
        secondary: (
          <Dialog.Button
            hierarchy='secondary'
            color='neutral'
            label='Later'
            onClick={() => {
              postUserPasswordApi({ changePasswordLater: true });
            }}
          />
        ),
      },
    });
  }

  return {
    modalOpenAtom,
    openPasswordChangeRequiredModal,
  };
});
ninetyDaysPasswordUpdateBunja.debugLabel = 'ninetyDaysPasswordUpdateBunja';
